import { useEffect, useRef } from 'react';
import type { ProductUpsellModalState } from '@src/stores/productUpsell';
import { trackUpsellModalShown } from '../../analytics/upsellTracking';

interface UseUpsellModalEventTrackParams {
  open: boolean;
  modal: ProductUpsellModalState | undefined;
  offersCount: number;
  sellerAppId: string;
}

export const useUpsellModalEventTrack = ({ open, modal, offersCount, sellerAppId }: UseUpsellModalEventTrackParams) => {
  const shownKeyRef = useRef<string>('');
  const openedAtRef = useRef<number>(0);

  useEffect(() => {
    if (!open || !modal) return;

    const key = `${modal.widgetId}:${modal.sourceProductId}`;
    if (shownKeyRef.current === key) return;

    shownKeyRef.current = key;
    openedAtRef.current = Date.now();
    trackUpsellModalShown(modal.sourceProductId, sellerAppId, offersCount);
  }, [open, modal, offersCount, sellerAppId]);

  return openedAtRef;
};
